import React from 'react';
import GruserModuleLoader from '@wix/da-gruser-shared/pkg/redux/module';
import { useSelector } from 'react-redux';
import { getDeviationGruser } from '../../../../DeviationPage/redux/selectors';
const DeviationGruserLoader = ({ deviation })=>{
    var _deviation_extended, _deviation;
    const gruser = useSelector((state)=>getDeviationGruser(state, deviation));
    return /*#__PURE__*/ React.createElement(GruserModuleLoader, {
        gruser: gruser,
        gruserPage: (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_extended = _deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended['gruserPage']
    });
};
DeviationGruserLoader.displayName = 'DeviationGruserLoader';
export default DeviationGruserLoader;
